<template> 
    <div class="news">
        <!-- Banner -->
        <Banner name="banner_images" v-if="route.name == 'images'" />
        <Banner name="banner_videos" v-else-if="route.name == 'video'" />
        <div class="news-banner" v-else>
            <div class="news-banner-bg" v-if="bannerData.length" @click="handleClick(bannerData[0])">
                <div class="news-banner-bg__tag">{{ lang.important }}</div>
                <img :src="bannerData[0].cover_image_url || 'https://edu-img.therol.cn/autohk/11.png'" class="news-banner-bg__cover">
                <div class="news-banner-bg__content">
                    <div class="title">{{ bannerData[0].title }}</div>
                    <div class="time">
                        <img src="@assets/article/icon_day.png" srcset="@assets/article/icon_day@2x.png 2x" />
                        {{ dayjs(bannerData[0].publish_time).format('YYYY/MM/DD')  }}
                    </div>
                    <div class="summary">{{ bannerData[0].summary }}</div>  
                    <div class="more">
                        {{ lang.more }}
                        <img src="@assets/news/icon_next.png" srcset="@assets/news/icon_next@2x.png 2x" alt="" />
                    </div>
                </div>
            </div>
        </div>
        
        <!-- 列表 -->
        <div class="news-center">
            <div class="news-center__tabs" v-if="route.name == 'news'">
                <div class="item" :class="[articleParam.news_type == 'important' ? 'active' : '']" @click="setTabs('important')">{{ lang.important }}</div>
                <div class="item" :class="[articleParam.news_type == 'industry' ? 'active' : '']" @click="setTabs('industry')">{{ lang.industry }}</div>
            </div>
            <div class="news-center__tabs" v-else>
                <div class="item" :class="[articleParam.year == '2026' ? 'active' : '']" @click="setTabs('2026')">2026</div>
                <div class="item" :class="[articleParam.year == '2025' ? 'active' : '']" @click="setTabs('2025')">2025</div>
            </div>

            <div class="news-center__content">
                <div class="news-center__content__left">
                    <div class="news-center__content__left__list">
                        <ArticleCard v-for="(item, index) in articleList" :key="item.id" :item="item" 
                                    :type="route.name" :currentIndex="index" :images="previewList" />
                    </div>

                    <div class="news-center__content__left__pagination" v-if="articleList.length">
                        <Pagination
                            :total="pagination.total"
                            :page-size="pagination.page_size"
                            :current-page="pagination.page - 1"
                            @page-change="setPage"
                        />
                    </div>
                    
                </div>

                <div class="news-center__content__right">
                     <Hot class="hot" />
                </div>
            </div>
        </div>
    </div> 
</template>

<script setup>
    import { useRouter, useRoute } from 'vue-router'
    const router = useRouter()
    const route = useRoute();
    import dayjs from 'dayjs';
    import { onMounted, ref, watch } from 'vue';
    import Hot from './components/hot.vue';
    import ArticleCard from './components/articleCard.vue';
    import { ArticleListAPI, BannerListAPI } from '@/api/common.js';
    import Pagination from '@/components/pagination/index.vue';
    import Banner from '@/components/banner/index.vue';

    // 语言包
    const language = localStorage.getItem("language") || "zh"
    const lang = ref({})
    import(`@/language/${language}.js`).then(data => {
        lang.value = data.default.news
    })   
    
    // banner要闻参数
    const bannerParam = ref({
        category: "news",
        is_top: "news_top",
        page: 1,
        page_size: 1
    })

    const bannerData = ref([])

    // banner单条数据获取
    const getBannerData = () => {
        ArticleListAPI(bannerParam.value).then(res => {
            bannerData.value = res.list
        });
    }

    // 切换TAB
    const setTabs = (type) => {
        route.name == 'news' ? articleParam.value.news_type = type : articleParam.value.year = type
        articleParam.value.page = 1 
        getArticleList()  
    }

    // 切换页码
    const setPage = (page) => {
        articleParam.value.page = page + 1
        getArticleList()
        window.scrollTo({ top: 0, behavior: 'smooth' });   
    }

    // 新闻参数
    const articleParam = ref({
        page: 1,
        page_size: 6
    })

    // 新闻分页数据
    const pagination = ref({
        page: 1,
        page_size: 6,
        total: 0,
        total_pages: 0
    })

    // 新闻列表
    const articleList = ref([])

    // 图片预览列表
    const previewList = ref([])

    // 新闻列表获取
    const getArticleList = () => {
        const AIP = route.name == 'images' ? BannerListAPI : ArticleListAPI
        AIP(articleParam.value).then(res => {
            articleList.value = res.list
            pagination.value = res.pagination
            if(route.name == 'images') {
                previewList.value = []
                articleList.value.forEach(item => {
                    previewList.value.push(item.file_url)
                })
            }
        });
    }

    // 跳转文章详情
    const handleClick = (item) => {
        router.push({ path: `/article/${item.id}` })
    }

    onMounted(() => {
        setParam()
    })

    const setParam = () => {
        articleParam.value = { page: 1, page_size: 6 }

        if(route.name == 'news') {
            articleParam.value.news_type = 'important'
            getBannerData()
        } else if(route.name == 'video') {
            articleParam.value.news_type = 'video'
            articleParam.value.year = '2026'
        }else if(route.name == 'images') {
            articleParam.value.year = '2026'
            articleParam.value.image_type = "image"
        }

        getArticleList()
    }
    
    // 监听路由变化
    watch(
        () => route.name,
        () => {   
            setParam()
        }
    )
</script>

<style lang="scss" scoped>
    .news {
        min-width: 1200px;

        &-banner {
            width: 100%;
            height: 549px;
            background-color: #F8FAFC;
            padding-top: 58px;
            box-sizing: border-box;

            &-bg {
                width: 1200px;
                margin: auto;
                height: 400px;
                border-radius: 30px;
                background-color: #FFFFFF;
                display: flex;
                position: relative;
                cursor: pointer;

                &__cover {
                    width: 734px;
                    height: 400px;
                    border-radius: 30px 0px 0px 30px;
                    object-fit: cover;
                }

                &__tag {
                    position: absolute;
                    padding: 0 15px;
                    height: 24px;
                    border-radius: 12px;
                    background-color: #F7F3FE;
                    line-height: 24px;
                    text-align: center;
                    left: 22px;
                    top: 22px;
                    font-family: PingFangSC-medium;
                    color: #6366F1;
                    font-weight: 500;
                    font-size: 12px;
                    letter-spacing: 1px;
                }

                &__content {
                    padding: 36px 24px;
                    position: relative;

                    .title {
                        font-family: PingFangSC-medium;
                        color: #333333;
                        font-weight: 500;
                        font-size: 24px;
                        line-height: 30px;
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        -webkit-box-orient: vertical;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }

                    .time {
                        margin-bottom: 24px;
                        font-family: Roboto-regular;
                        color: #999999;
                        font-weight: 400;
                        font-size: 14px;
                        line-height: 20px;
                        display: flex;
                        align-items: center;
                        margin-top: 4px;

                        img {
                            margin-right: 10px;
                        }
                    }

                    .summary {
                        color: #53433F;
                        font-weight: 400;
                        font-size: 16px;
                        line-height: 26px;
                        display: -webkit-box;
                        -webkit-line-clamp: 7;
                        -webkit-box-orient: vertical;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }

                    .more {
                        font-family: PingFangSC-medium;
                        color: #0E4EAD;
                        font-weight: 500;
                        font-size: 14px;
                        line-height: 20px;
                        cursor: pointer;
                        display: flex;
                        align-items: center;
                        position: absolute;
                        bottom: 36px;

                        img {
                            margin-left: 6px;
                        }
                    }

                    .more:hover {
                        opacity: 0.75;
                    }
                }
                
            }
        }

        &-center {
            width: 1200px;
            margin: 0 auto;
            padding: 50px 0;
            

            &__tabs {
                display: flex;
                color: #333333;
                font-weight: 400;
                font-size: 20px;
                cursor: pointer;

                .item {
                    padding-bottom: 4px;
                    line-height: 28px;
                    width: 88px;
                    text-align: center;
                    margin-right: 20px;
                }

                .item:hover {
                    color: #0C3B81;
                }

                .active {
                    font-family: PingFangSC-medium;
                    border-bottom: 3px solid #181E5F;
                    color: #0C3B81;
                }

            }

            &__content {
                display: flex;
                margin-top: 33px;
                

                &__left {
                    flex: 1;

                    &__list {
                        display: flex;
                        flex-wrap: wrap;
                        justify-content: space-between;
                        // height: 1120px;
                    }
                    
                    &__pagination {
                        margin-top: 36px;
                        display: flex;
                        justify-content: flex-end;
                        align-items: center;
                        margin-right: -20px;
                    }
                }

                &__right {
                    margin-left: 24px;
                }
            }
            
        }

        
    }
    /* 响应式布局 */
@media (max-width: 768px) {
    .news {
        min-width: 100%;

        &-banner {
            width: 100%;
            height: auto;
            padding: 24px 12px;

            &-bg {
                width: 100%;
                margin: auto;
                height: auto;
                border-radius: 10px;
                display: block;
                

                &__cover {
                    width: 100%;
                    height: 200px;
                    border-radius: 10px 10px 0px 0px;
                }

                &__tag {
                    line-height: 24px;
                    left: 12px;
                    top: 12px;
                }

                &__content {
                    padding: 12px;
                    padding-bottom: 36px;

                    .title {
                        font-size: 14px;
                        line-height: 18px;
                    }

                    .time {
                        margin-bottom: 4px;
                        font-size: 10px;
                        line-height: 16px;


                        img {
                            margin-right: 4px;
                            width: 10px;
                            height: 10px;
                        }
                    }

                    .summary {
                        font-size: 12px;
                        line-height: 20px;
                        margin-bottom: 10px;
                    }

                    .more {
                        font-size: 10px;
                        line-height: 26px;
                        bottom: 12px;

                        img {
                            margin-left: 4px;
                            width: 10px;
                            height: 10px;
                        }
                    }

                    .more:hover {
                        opacity: 0.75;
                    }
                }
                
            }
        }

        &-center {
            width: 100%;
            margin: 0 auto;
            padding: 24px 12px;
            box-sizing: border-box;
            
            &__tabs {
                display: flex;
                font-size: 14px;

                .item {
                    padding-bottom: 4px;
                    line-height: 28px;
                    width: 78px;
                    text-align: center;

                }

            }

            &__content {
                display: block;
                margin-top: 15px; 

                &__left {
                    width: 100%;
                    // flex: 1;
                    margin-bottom: 24px;

                    &__list {
                        display: flex;
                        flex-wrap: wrap;
                        justify-content: space-between;
                        // height: 1120px;
                    }
                    
                    &__pagination {
                        margin-top: 18px;
                        margin-right: 0;
                    }
                }

                &__right {
                    margin: 0 auto;
                    
                    .hot {
                        margin: 0 auto;
                    }
                }
            }
            
        }
    }
}
</style>

